import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";
// 首页布局配置
export const getHomepage = (params) =>
  request(`${mock}/v1/layout/homepage`, "get", { params });
//富文本配置
export const getLayoutInfo = (params) =>
  request(`${mock}/v1/layout/info`, "get", { params });
